if (!customElements.get("atlas-cart-sticky")) {
  customElements.define(
    "atlas-cart-sticky",
    class AtlasCartSticky extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia("(max-width: 749px)");
        this.standardCheckout = document.getElementById("checkout")?.closest(".cart-ctas");
        this.standardCheckoutButton = document.getElementById("checkout");
        this.stickyCheckoutButton = this.querySelector(".atlas-cart-sticky__checkout");
        this.standardCheckoutVisible = true;
        this.onViewportChange = () => this.updateVisibility();
        this.onCheckout = () => this.standardCheckoutButton?.click();
        this.mediaQuery.addEventListener?.("change", this.onViewportChange);
        this.stickyCheckoutButton?.addEventListener("click", this.onCheckout);

        if (this.standardCheckout && "IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.standardCheckoutVisible = entry.isIntersecting;
              this.updateVisibility();
            },
            { threshold: 0.15 },
          );
          this.observer.observe(this.standardCheckout);
        } else {
          this.standardCheckoutVisible = true;
        }

        this.updateVisibility();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mediaQuery?.removeEventListener?.("change", this.onViewportChange);
        this.stickyCheckoutButton?.removeEventListener("click", this.onCheckout);
        document.body.classList.remove("atlas-cart-sticky-active");
      }

      updateVisibility() {
        const hasItems = !document.getElementById("main-cart-footer")?.classList.contains("is-empty");
        const shouldShow = this.mediaQuery.matches && hasItems && !this.standardCheckoutVisible;
        this.hidden = !shouldShow;
        this.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        document.body.classList.toggle("atlas-cart-sticky-active", shouldShow);
      }
    },
  );
}
